import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

const getFunnelStage = (variant) => {
    let funnelStage;

    if (variant === 'tripSummary') {
        funnelStage = 'trip_summary';
    } else if (variant === 'timeTable') {
        funnelStage = 'city_to_city';
    } else if (variant === 'travelOptions') {
        funnelStage = 'travel_options';
    } else if (variant === 'user_accounts') {
        funnelStage = 'user_accounts';
    } else {
        funnelStage = 'search';
    }

    return funnelStage;
};

function tripDetailsExpanded({
    breakpoint,
    carrierCode,
    expanded,
    isRouted,
    seats,
    tripId,
    variant,
}) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_tripsummary',
        label: 'change_trip',
        property: {
            trip_id: tripId,
        },
    });

    const action = expanded
        ? 'hide'
        : 'show';

    const funnelStage = getFunnelStage(variant);

    amplitude.track('trip_card_interacted', {
        breakpoint,
        carrier_code: carrierCode,
        funnel_stage: funnelStage,
        interaction_type: `${action}_transfer_details`,
        is_routed: isRouted,
        pax_count: seats,
        trip_id: tripId,
    });
}

export default {
    tripDetailsExpanded,
};
